import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';

const monthLabels = [
  "1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월", "합계"
];

const StatManager = ({year}) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get(`/stat/manager/${year}`);
                const payload = response.data.list;
                setList(payload);
            } catch (error) {
                console.error('Error fetching manager stat data:', error);
            }
        }
        fetchData();
    }, [year]);

    return (
        <TableContainer component={Paper}>
            <Typography variant="h6" sx={{ p: 2 }}>
                담당자별 통계
            </Typography>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#60718b" }}>
                        <TableCell align="center" sx={{ color: "#fff", width: 80 }}><strong>담당자</strong></TableCell>
                        {monthLabels.map((label, index) => (
                            <TableCell key={index} align="right" sx={{ color: "#fff", width: 140 }}><strong>{label}</strong></TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                {list.map((row, idx) => (
                    <TableRow 
                        key={idx}
                        sx={{
                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#eff3f9"
                        }
                    }>
                    <TableCell align="center">{row.task_code}</TableCell>
                    {monthLabels.map((month, mIdx) => (
                        <TableCell key={mIdx} align="right" >
                            {Number(row[month]).toLocaleString()}원
                        </TableCell>
                    ))}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};


export default StatManager;